export default "__VITE_ASSET__acfcaaa8__"